(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('fax-number', {
                parent: 'entity',
                url: '/fax-number',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN],
                    pageTitle: 'FaxNumbers'
                },
                ncyBreadcrumb: {
                    label: 'Facility Phone Numbers',
                    parent: 'entity'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/fax-number/list/fax-number.html',
                        controller: 'FaxNumberController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();
